import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from 'styled-components';
import { AuthProvider } from './app/contexts/AuthContext';
import { ResultProvider } from './app/contexts/ResultContext';
import AppRoutes from './app/routes';
import { GlobalStyles } from './app/globals';
import { darkTheme } from './app/themes/dark';
import {lightTheme } from './app/themes/light';

// Usar uma união dos tipos de temas
type AppTheme = typeof lightTheme | typeof darkTheme;

const App: React.FC = () => {
  // Claro por padrao — o alternador segue funcionando para quem quiser o escuro.
  const [currentTheme, setCurrentTheme] = React.useState('lightTheme');
  const theme: AppTheme = currentTheme === 'lightTheme' ? lightTheme : darkTheme;

  return (
    <AuthProvider>
      <ResultProvider>
        <ThemeProvider theme={theme as any}>
          <GlobalStyles />
          <AppRoutes />
        </ThemeProvider>
      </ResultProvider>
    </AuthProvider>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);